import React from 'react';
import _ from 'lodash';

import { messageUtility } from '../../utilities/messageUtility';
import FieldBulletinBoardsService from '../../services/fieldBulletinBoard/FieldBulletinBoardsService';
import { useFieldBulletinBoardDetail } from '../../services/fieldBulletinBoard/FieldBulletinBoardDetailContext';
import { DATE_TIME_FORMAT, IMPORTANCE_TYPE } from '../../utilities/constants';

import { Confirmation, Information } from '../modals/common';

import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { TARGET_PARTNER_COMPANY_TYPE } from '@bld/bld-libs/constants';
import { Button } from '@bld/bld-libs/components';
import ErrorIcon from '@mui/icons-material/Error';

import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardDetail.scss';
import MailIcon from '../../images/icon/icon--mail-5.svg';
import FileDownload from '../../images/icon/icon--download-5.svg';

export function FieldBulletinBoardDetailForPrime() {
  const {
    getDetailInfo,
    getModalDisplayInfo,
    getErrorDialogProperty,
    handleDownload,
    handleStop,
    executeStop,
    closeConfirmDialog,
    closeCompleteDialog,
  } = useFieldBulletinBoardDetail();

  const detail = getDetailInfo();
  const documents = detail.documents;

  /**
   * エラーダイアログ用のタイトル
   * */
  const ErrorDialogTitle = () => {
    return (
      <React.Fragment>
        <ReportProblemOutlinedIcon
          sx={{ fill: '#d32f2f', verticalAlign: 'middle' }}
        />
        {getErrorDialogProperty().title}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {/* お知らせ内容 */}
      <div className={`${Styles.detailPrime}`}>
        <div className={'detail-group contents'}>
          <div className='detail-list'>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-26')}
              </span>
              {detail.importance_type === IMPORTANCE_TYPE.CHECK ? (
                <span className='detail-item__value'>
                  <ErrorIcon className='detail-item__importance-icon' />
                  {detail.title}
                </span>
              ) : (
                <span className='detail-item__value'>{detail.title}</span>
              )}
            </div>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-29')}
              </span>
              <span className='detail-item__value pre-wrap'>
                {detail.contents}
              </span>
            </div>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-30')}
              </span>
              <div className='detail-files'>
                {/* ダウンロードファイル */}
                {!_.isEmpty(documents) &&
                  _.map(documents, (info, key) => {
                    return (
                      <div key={key} className='detail-files__name'>
                        <div className='detail-files__txt'>
                          {info.file_name}
                        </div>
                        <div className='detail-files__btn'>
                          <Button
                            color='primary'
                            className='download-btn'
                            variant='contained'
                            onClick={() => handleDownload(info.id)}
                          >
                            <img src={FileDownload} className='download-icon' />
                          </Button>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        {/* 公開先設定 */}
        <div className={'detail-group publish-setting'}>
          <h1 className='detail-group__title'>
            {messageUtility.getMessage('I-000-165-18')}
          </h1>
          <div className='detail-list'>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-19')}
              </span>
              <span className='detail-item__value'>
                {FieldBulletinBoardsService.convertDate(
                  detail.publication_start_at,
                  DATE_TIME_FORMAT.weekdaySlashDateFormat
                )}
              </span>
            </div>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-20')}
              </span>
              <span className='detail-item__value'>
                {messageUtility.getMessage('I-000-166-19')}
                {detail.target_partner_company_type ===
                TARGET_PARTNER_COMPANY_TYPE.ONLYFIRST.TYPE_NUMBER
                  ? messageUtility.getMessage('I-000-165-22')
                  : messageUtility.getMessage('I-000-165-21')}
              </span>
            </div>
            <div className='detail-item'>
              <span className='detail-item__label'>
                {messageUtility.getMessage('I-000-165-23')}
              </span>
              {detail.is_send_mail ? (
                <span className='detail-item__value'>
                  <img src={MailIcon} className='detail-item__mail-icon' />
                  {messageUtility.getMessage('I-000-165-24')}
                </span>
              ) : (
                <span className='detail-item__value'>
                  {messageUtility.getMessage('I-000-166-02')}
                </span>
              )}
            </div>
          </div>
        </div>
        {!_.isEmpty(detail.history) && (
          <div className={'detail-group history'}>
            <h1 className='detail-group__title'>
              {messageUtility.getMessage('I-000-166-03')}
            </h1>
            <div className='detail-list'>
              <div className='detail-history'>
                <span className='detail-history__label'>
                  {messageUtility.getMessage('I-000-166-03')}
                </span>
                <table className='detail-history__table'>
                  <thead>
                    <tr className='detail-history__table-header'>
                      <th className='table-header__status'>
                        {messageUtility.getMessage('I-000-166-04')}
                      </th>
                      <th className='table-header__name'>
                        {messageUtility.getMessage('I-000-166-05')}
                      </th>
                      <th className='table-header__date-time'>
                        {messageUtility.getMessage('I-000-166-06')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className='detail-history__table-row'>
                      <td>{messageUtility.getMessage('I-000-166-07')}</td>
                      <td>
                        {FieldBulletinBoardsService.convertNameAndRole(
                          detail.history.created.user_name,
                          detail.history.created.role_code
                        )}
                      </td>
                      <td>
                        {FieldBulletinBoardsService.convertDate(
                          detail.history.created.date_time,
                          DATE_TIME_FORMAT.weekdaySlashDateTimeFormat
                        )}
                      </td>
                    </tr>
                    <tr className='detail-history__table-row'>
                      <td>{messageUtility.getMessage('I-000-166-08')}</td>
                      <td>
                        {FieldBulletinBoardsService.convertNameAndRole(
                          detail.history.updated.user_name,
                          detail.history.updated.role_code
                        )}
                      </td>
                      <td>
                        {FieldBulletinBoardsService.convertDate(
                          detail.history.updated.date_time,
                          DATE_TIME_FORMAT.weekdaySlashDateTimeFormat
                        )}
                      </td>
                    </tr>
                    <tr className='detail-history__table-row'>
                      <td>{messageUtility.getMessage('I-000-166-09')}</td>
                      <td>
                        {FieldBulletinBoardsService.convertNameAndRole(
                          detail.history.publication_stopped.user_name,
                          detail.history.publication_stopped.role_code
                        )}
                      </td>
                      <td>
                        {FieldBulletinBoardsService.convertDate(
                          detail.history.publication_stopped.date_time,
                          DATE_TIME_FORMAT.weekdaySlashDateTimeFormat
                        )}
                      </td>
                    </tr>
                    <tr className='detail-history__table-row'>
                      <td>{messageUtility.getMessage('I-000-166-10')}</td>
                      <td>
                        {FieldBulletinBoardsService.convertNameAndRole(
                          detail.history.publication_restarted.user_name,
                          detail.history.publication_restarted.role_code
                        )}
                      </td>
                      <td>
                        {FieldBulletinBoardsService.convertDate(
                          detail.history.publication_restarted.date_time,
                          DATE_TIME_FORMAT.weekdaySlashDateTimeFormat
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* エラーダイアログ */}
      <Information
        visible={
          _.has(getModalDisplayInfo(), 'error') && getModalDisplayInfo().error
        }
        title={<ErrorDialogTitle />}
        message={getErrorDialogProperty().message}
        onClose={() => closeConfirmDialog()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
      {/* 公開停止確認ダイアログ */}
      <Confirmation
        visible={
          _.has(getModalDisplayInfo(), 'stop') && getModalDisplayInfo().stop
        }
        multilineText={true}
        title={messageUtility.getMessage('I-000-166-14')}
        message={messageUtility.getMessage('I-000-166-15')}
        isNegative={true}
        confirmButtonText={messageUtility.getMessage('I-000-166-18')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={() => executeStop()}
        onCancel={() => closeConfirmDialog()}
      />
      {/* 公開停止完了 */}
      <Information
        visible={
          _.has(getModalDisplayInfo(), 'stopComplete') &&
          getModalDisplayInfo().stopComplete
        }
        title={messageUtility.getMessage('I-000-166-16')}
        message={messageUtility.getMessage('I-000-166-17')}
        onClose={() => closeCompleteDialog()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardDetailForPrime.jsx